import React from 'react';
import { Button } from './ui/button';

export default function Header({ hasBanner = false }) {
  return (
    <header 
      className={`fixed left-0 right-0 z-40 bg-white/95 supports-[backdrop-filter]:bg-white/90 backdrop-blur-md border-b border-slate-200 shadow-sm transition-all duration-300 ${
        hasBanner ? 'top-[140px] md:top-[56px]' : 'top-0'
      }`}
    >
      <div className="mx-auto max-w-[1200px] px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-14 md:h-16">
          <div className="flex-shrink-0 flex items-center gap-2">
            <img 
              src="https://customer-assets.emergentagent.com/job_trade-coach-10/artifacts/2yhk72vp_Logo--Myeai---white%20%281%29.jpg"
              alt="MYeAI Logo"
              className="h-7 md:h-10 w-auto rounded"
              data-testid="header-logo-image"
            />
            <span 
              className="text-sm md:text-xl font-bold text-[#162959]"
              data-testid="header-logo"
            >
              Trading Compass
            </span>
          </div>
          <nav className="flex items-center gap-2 md:gap-4">
            <a 
              href="https://chat.whatsapp.com/Dp0q9F6Z3TZJLOAVsXugNE"
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs md:text-sm text-[#162959] hover:text-[#337AF7] transition-colors font-medium hidden sm:inline"
              data-testid="nav-community-link"
            >
              Join Community
            </a>
            <a 
              href="https://auth.emergentagent.com/?redirect=https://myeaitradingcompass.com" 
              className="text-xs md:text-sm text-[#162959] hover:text-[#337AF7] transition-colors font-medium"
              data-testid="nav-login-link"
            >
              Login
            </a>
            <a
              href="https://myeaitradingcompass.com"
              className="rounded-lg md:rounded-xl bg-[#337AF7] text-white font-semibold px-3 md:px-4 py-1.5 md:py-2 text-xs md:text-sm shadow-md hover:bg-[#2563eb] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#337AF7]/50 transition-colors duration-200 inline-block"
              data-testid="nav-signup-button"
            >
              Start Free Trial
            </a>
          </nav>
        </div>
      </div>
    </header>
  );
}